import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    flex: 1,
    flexDirection: 'column',
    padding: theme.spacing(0.625, 0),
  },
  progressContainer: {
    width: '100%',
    position: 'relative',

    '& .MuiLinearProgress-root': {
      backgroundColor: theme.palette.progressBar.default,
      height: theme.spacing(1),
      borderRadius: theme.spacing(0.5),
    },

    '& .MuiLinearProgress-bar': {
      borderRadius: theme.spacing(0.5),
    },

    '&.live .MuiLinearProgress-bar': {
      backgroundColor: theme.palette.progressBar.live,
    },

    '&.pending .MuiLinearProgress-bar': {
      backgroundColor: theme.palette.progressBar.pending,
    },

    '&.checkin .MuiLinearProgress-bar': {
      backgroundColor: theme.palette.progressBar.pending,
    },

    '&.finished .MuiLinearProgress-bar': {
      backgroundColor: theme.palette.progressBar.finished,
    },

    '&.canceled .MuiLinearProgress-bar': {
      backgroundColor: theme.palette.progressBar.canceled,
    },
  },
  readyToLive: {
    '&.pending .MuiLinearProgress-bar': {
      backgroundColor: theme.palette.progressBar.live,
    },
  },
}));
